import type { AppMode } from '@iheartjane/types';
import compact from 'lodash-es/compact';
import flow from 'lodash-es/flow';

// eslint-disable-next-line no-restricted-imports
import type { StoreSpecial } from '@jane/shared/models';

import { sortSearchFilterItems } from './sortSearchFilterItems';

export const sortAndLabelSpecials = (specials: StoreSpecial[]) =>
  flow([
    (facets, appMode) =>
      Object.entries(facets).map((facet: [string, unknown]) =>
        matchSpecials(specials, facet, appMode)
      ),
    compact,
    (items) => sortSearchFilterItems({ items, sort: 'alpha' }),
  ]);

export const matchSpecials = (
  specials: StoreSpecial[],
  facet: [string, unknown],
  appMode?: AppMode
) => {
  const [value, count] = facet;

  const special = specials?.find(
    (s) =>
      s.id === parseInt(value) &&
      (appMode !== 'kiosk' || s.reservation_modes?.kiosk)
  );

  if (!special) return undefined;

  return {
    count,
    key:
      special.special_type === 'bulk_pricing'
        ? 'applicable_bulk_special_ids'
        : special.special_type === 'bundle'
          ? 'applicable_bundle_special_ids'
          : special.special_type === 'cart_total'
            ? 'applicable_cart_total_special_ids'
            : 'applicable_special_ids',
    label: special.title,
    value,
  };
};
